document.addEventListener("DOMContentLoaded", function () {
  const headStrip = document.querySelector(".head-strip");
  const mobileFacets = document.querySelector(".mobile-facets.mobile_filter");
  const cross = document.querySelector(".head-strip .cross");
  const header = document.querySelector('.section-header');
  const blogHeader = document.querySelector('.container-fluid.logo-strip.logo-mobile');
  const announcementHeader = document.querySelector('.announcement-bar-section-strip');
  // to keep the announcement closed until session is completed once the user closes it. 
  if (!sessionStorage.getItem("announcementClosed")) {
    headStrip.style.display = "block";
  } else {
    headStrip.style.display = "none";
    header.style.top= 0;
    if (blogHeader) {
      blogHeader.style.top = 0;
    }
    if (announcementHeader) {
      announcementHeader.style.minHeight = '0px';
    }
  }

  function updateMobileFacetsHeight() {
    if (!mobileFacets) return;

    if (window.getComputedStyle(headStrip).display === "none") {
      if (window.innerWidth < 400) {
        mobileFacets.style.height = "78%";
      } else if (window.innerWidth >= 400 && window.innerWidth < 768) {
        mobileFacets.style.height = "84%";
      }
    } else {
      if (window.innerWidth < 400) {
        mobileFacets.style.height = "73%";
      } else if (window.innerWidth >= 400 && window.innerWidth < 768) {
        mobileFacets.style.height = "79%";
      }
    }
  }
  updateMobileFacetsHeight();
  window.addEventListener("resize", updateMobileFacetsHeight);
  if (cross) {
    cross.addEventListener("click", function () {
      if (headStrip) {
        headStrip.style.display = "none";
        // to keep announcment bar closed till the tab is closed.
        sessionStorage.setItem("announcementClosed", "true");
        
        header.style.top = 0;
        if (blogHeader) {
          blogHeader.style.top = 0;
        }
        if (announcementHeader) {
          announcementHeader.style.minHeight = '0px';
        }
      }
      updateMobileFacetsHeight();
    });
  }
});

window.onload = function () {
  setTimeout(function () {
    const menuItems1 = document.querySelectorAll(
      ".huk_menu_item_level_0 .huk_menu_submenu_type_tab ul.huk_menu_submenu_tab_control li a .huk_menu_item_text"
    );
    menuItems1.forEach((item) => {
      item.style.cssText += "font-weight: 700 !important;";
    });
    const menuItems2 = document.querySelectorAll(
      ".menu-drawer__menu .huk_menu_item_level_0 a .huk_menu_item_text"
    );
    const menuItems3 = document.querySelectorAll(
      ".menu-drawer__menu .huk_menu_item_level_3 a .huk_menu_item_text"
    );
    menuItems2.forEach((item) => {
      item.style.cssText += "font-weight: 700 !important;";
    });
    menuItems3.forEach((item) => {
      item.style.cssText += "font-weight: 400 !important;";
    });
  }, 1500);

  let noDiscount = document.querySelector('.no-coupon');
    if(noDiscount){
      let cartCoupon = document.querySelector('.cart-coupon-button');
      let texts = Array.from(cartCoupon.querySelectorAll('text'));
      texts.forEach((text)=>{
        text.classList.add('hidden')
      })
    }
};

(function () {
  var editAddressBtns = document.querySelectorAll(".edit-address");
  var cancelEditAddressBtn = document.querySelector(".cancel-edit-address");
  editAddressBtns.forEach(function (editAddressBtn) {
    editAddressBtn.addEventListener("click", function () {
      var nextSibling = editAddressBtn.nextElementSibling;
      while (nextSibling && nextSibling.tagName !== "DIV") {
        nextSibling = nextSibling.nextElementSibling;
      }
      if (nextSibling && nextSibling.tagName === "DIV") {
        if (
          nextSibling.style.display === "none" ||
          nextSibling.style.display === ""
        ) {
          nextSibling.style.display = "block"; // Standard div display
        } else {
          nextSibling.style.display = "none";
        }
      }
      cancelEditAddressBtn.addEventListener("click", function () {
        nextSibling.style.display = "none";
      });
    });
  });
})();

(function () {
  var addAddressBtn = document.querySelector(".add-address-btn");
  var addAddressDiv = document.getElementById("AddAddress");
  var cancelAddressBtn = document.querySelector(".cancel-address");

  if (addAddressBtn && addAddressDiv && cancelAddressBtn) {
    addAddressBtn.addEventListener("click", function () {
      // Toggle display of sibling div
      if (
        addAddressDiv.style.display === "none" ||
        addAddressDiv.style.display === ""
      ) {
        addAddressDiv.style.display = "block";
      } else {
        addAddressDiv.style.display = "none";
      }
    });

    cancelAddressBtn.addEventListener("click", function () {
      addAddressDiv.style.display = "none"; // Hide AddAddress
    });
  }
})();


document.addEventListener("DOMContentLoaded", () => {
  setTimeout(function () {
    const headerIcon = document.querySelector(".header__icon span svg");

    if (headerIcon) {
      headerIcon.addEventListener("click", () => {
        const menuItem = document.querySelector(
          "#menu-drawer .menu-drawer__navigation .menu-drawer__menu li.huk_menu_item_level_0"
        );

        if (menuItem) {
          menuItem.classList.add("huk_menu_item_active");
        } else {
          console.log("Menu item not found");
        }
      });
    } else {
      console.log("Header icon not found");
    }
  }, 200);
});

$(document).ready(function() {
  setTimeout(function() {
    var $tabSectionHeight = $('.home-pro-tabs-cnt');
    var $tabSectionContent = $('#home-best-selling');
    
    if ($tabSectionHeight.length && $tabSectionContent.length) {

      function adjustMinHeight() {
        var tabSectionContentHeight = $tabSectionContent.outerHeight();

        if (tabSectionContentHeight > 0) {
          $tabSectionHeight.css('min-height', tabSectionContentHeight + 'px');
        } else {
          console.warn('Content height is zero.');
        }
      }

      adjustMinHeight();
      $(window).on('resize', adjustMinHeight);
    } else {
      console.error('Required elements are not found on the page.');
    }
  }, 2000);
});



document.addEventListener("DOMContentLoaded", function() {
  const links = document.links; 
  for (let i = 0, linksLength = links.length; i < linksLength; i++) { 
    if (links[i].hostname !== window.location.hostname) { 
      links[i].target = '_blank'; 
      links[i].rel = 'noreferrer noopener'; 
    } 
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector('.newsletter-form');
  const submitBtn = document.getElementById('Subscribe');
  const errorMsg = document.getElementById('error-msg');
  const errorDiv = document.getElementsByClassName('newsletter-form__message');

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();

    const emailInput = form.querySelector('input[type="email"]');
    const email = emailInput.value.trim();

    if (isValidEmail(email)) {
      form.submit();
    } else {
      errorMsg.textContent = 'Please enter a valid email address.';
      errorMsg.style.display = 'inline-flex';
      for (let i = 0; i < errorDiv.length; i++) {
        errorDiv[i].style.display = 'none';
      }
    }
  }); // Correctly closed parentheses and semicolon

  submitBtn.addEventListener('click', (event) => {
    const emailInput = form.querySelector('input[type="email"]');
    const email = emailInput.value.trim();

    if (!isValidEmail(email)) {
      event.preventDefault();
      errorMsg.style.display = 'inline-flex';
      for (let i = 0; i < errorDiv.length; i++) {
        errorDiv[i].style.display = 'none';
      }
    }
    else {  
      errorMsg.style.display = 'none';
    }
  });
});

$(document).ready(function() {
    $('header .header__inline-menu .list-menu .huk_menu_item_level_0 .huk_menu_submenu .huk_menu_submenu_tab_control li').hover(function() {
        console.log('working');
        // First, remove 'huk_menu_submenu_tab_active' class from the parent 'li' inside 'huk_menu_item_level_0'
        $(this).closest('.huk_menu_item_level_0').children('.huk_menu_submenu_tab_active').removeClass('huk_menu_submenu_tab_active');
        
        // Then, remove 'huk_menu_submenu_tab_active' class from all siblings of the hovered 'li'
        $(this).siblings('.huk_menu_submenu_tab_active').removeClass('huk_menu_submenu_tab_active');
    });
});

// To scroll the page to bottom after form submit

function checkUrl() {
  const url = window.location.href;
  return url.indexOf("?customer_posted=true") !== -1 || url.indexOf("?contact[tags]=newsletter") !== -1;
}
document.addEventListener("DOMContentLoaded", function() {

const messageElement = document.querySelector('.newsletter-form__message');

if (messageElement) {
  // Do something with the message element
  console.log('Found newsletter form message element!');
  window.scrollTo(0, document.body.scrollHeight);
    document.querySelector('.newsletter-form__field-wrapper .field').style.display = 'none';
    document.querySelector('.newsletter-consent').style.display = 'none';
} else {
  console.log('Newsletter form message element not found.');
}

  

});

// Menu script starts here

$(document).ready(function () {
  $("#mySidenav .sub-menu > div, #mySidenav .sub-menu > ul").hide();
  $("#mySidenav .sub-menu > a, #mySidenav .sub-menu ul > li > a").click(function(event) {
    var $subMenu = $(this).parent(".sub-menu");
  
    if ($subMenu.length && !$subMenu.children("div, ul").is(':animated')) {
      var $currentSubMenu = $subMenu.children("div, ul");
      $currentSubMenu.slideToggle(100, function() {
        $(this).siblings('a').find(".right").toggleClass("fa-caret-up fa-caret-down");
      });
  
      $subMenu.toggleClass("active");
  
      $subMenu.siblings(".sub-menu").each(function() {
        var $otherSubMenu = $(this);
        if ($otherSubMenu.hasClass("active")) {
          $otherSubMenu.removeClass("active");
          $otherSubMenu.children("div, ul").slideUp(100, function() {
            $(this).siblings('a').find(".right").removeClass("fa-caret-up").addClass("fa-caret-down");
          });
        }
      });
    }
  
    if ($(this).parent().hasClass('has-children') || $(this).parent().hasClass('has-child')) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
  
  // Initialize the first sub-menu as active
  var $firstSubMenu = $("#mySidenav .sub-menu").first();
  $firstSubMenu.addClass("active");
  $firstSubMenu.children("div, ul").show();
  $firstSubMenu.children('a').find(".right").addClass("fa-caret-up").removeClass("fa-caret-down");

  $("#openMenu").click(function() {
    openNav();
    $('body').css("overflow", "hidden");
  });

  $("#closeMenu").click(function() {
    closeNav();
    $('body').css("overflow-y", "auto");
  });

  function openNav() {
    $("#mySidenav").css("width", "100%");
    $("#mySidenav").css("visibility", "visible");
  }

  function closeNav() {
    $("#mySidenav").css("width", "0");
    $("#mySidenav").css("visibility", "hidden");
  }
  $('#mySidenav .nav-item').each(function() {
      if ($(this).find('ul').length > 0) {
          $(this).addClass('has-children');
      }
  });
  $('#mySidenav .nav-item .sub-menu-container .sub-menu-container-li').each(function() {
      if ($(this).find('ul').length > 0) {
          $(this).addClass('has-child');
      }
  });
});

// strike out on unavailable variant 
$(document).ready(() => {
  const unavailableVariants = document.querySelectorAll('.metafield_variant.variant-qty_changer.unavailable_variant');
  unavailableVariants && unavailableVariants.forEach((variant)=> {
    const boxWidth = variant.offsetWidth;
    if (window.innerWidth > 990 ) {
      if (boxWidth >= 85 && boxWidth <= 90) {
        variant.classList.add('two-combo');
      } else if (boxWidth >= 110 && boxWidth <= 125) {
        variant.classList.add('three-combo');
      }
    } else {
      if (boxWidth >= 75 && boxWidth <= 85) {
        variant.classList.add('two-combo');
      } else if (boxWidth >= 100 && boxWidth <= 115) {
        variant.classList.add('three-combo');
      }
    }
  });
});
